import React, { Component } from 'react';
import  { Button } from 'antd';
import ReviewImages from './ReviewImages'
import ReviewImagesMobile from './ReviewImagesMobile'

class Review extends Component {

  state = {
    linkArray: [],
    imgArray: [],
    isMobile: false,
    possibleLabels: [],
    addingLabels: false,
    userAddedLabel: ''
  }

  // componentDidMount() {
  //   var check = false;

  //   (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    
  //   this.setState({
  //     isMobile: check
  //   })
  // }

  saveLabel = () => {
    let allLabels = this.state.possibleLabels
    allLabels.push(this.state.userAddedLabel)

    this.setState({
      possibleLabels: allLabels, 
      addingLabels: false,
      userAddedLabel: ''
    })
  }

  addLabels = () => {
    this.setState({
      addingLabels: !this.state.addingLabels
    })
  }

  reviewImages = async() => {
    if(!this.props.endpoints.dataEndPoint) { alert('Please enter endpoints in settings') }
    this.setState({ imgArray: [] })
    
    let response = await fetch(this.props.endpoints.dataEndPoint)
    let linkArray = await response.json();

    this.setState({ linkArray: linkArray })  
    
    linkArray.forEach(async(linkInfo) => {
      await this.showNextImage(linkInfo)
    })
  }

  formatLink = (linkInfo, type) => {
    let newString = ''
    let userEndpoint = ''
    if(type === 'img') {
      userEndpoint = this.props.endpoints.imgEndPoint
    } else if( type === 'save') {
      userEndpoint = this.props.endpoints.saveEndPoint
    }
    
    let sLink = userEndpoint.split('/')
    sLink.forEach((section, i) => {
      let sectionCopy = section.slice()
      var firstTwo = section.slice().substring(0, 2);
      var variable = sectionCopy.substring(2, section.length - 1);
      if(firstTwo === '${' ) {
        if(variable.includes('.')){
          let splitAgain = variable.split('.')
          let mappedVar2 = linkInfo[splitAgain[0]][splitAgain[1]]
          if(mappedVar2) {
            sLink[i] = linkInfo[splitAgain[0]][splitAgain[1]]
          }
        } else  {
          let mappedVar = linkInfo[variable]
          if(mappedVar) {
            sLink[i] = linkInfo[variable]
          }
        }
      }
    })

    newString = sLink.join('/')
    return newString
  }

  showNextImage = async(linkInfo) => {
    let formatedLink = this.formatLink(linkInfo, 'img')
    fetch(formatedLink)
      .then(response => response.blob())
      .then(image => {
        let finalImage = {
          linkInfo,
          src1: image,
          src2: URL.createObjectURL(image)
        }
        
        const newDaisy = new Image();
        newDaisy.src = URL.createObjectURL(image);

        let imagesArray = this.state.imgArray
        imagesArray.push(finalImage)
    
        this.setState({
          imgArray: imagesArray,
        }, () => { return URL.createObjectURL(image) })   
    });
  }

  updateImage = async(e, img, index) => {
    let formatedLink = this.formatLink(img.linkInfo, 'save')
    let url = formatedLink
    let data = {
      updatedWinner: e,
      oldWinner: img.linkInfo.classifiedData.winningClass.label,
      link: img.linkInfo
    }

    let newArr = this.state.imgArray
    newArr.splice(index, 1)
    this.setState({ 
      imgArray: newArr
    })

    const response = await fetch(url, {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data) // body data type must match "Content-Type" header
    });

    await response.json() // parses JSON response into native JavaScript objects
  }

  render() {
    return (
      <div>
        {this.state.isMobile && 
          <div>  <br /><br/>
          <h1>SHOW THE MOBILE VERSION</h1> <br /><br/>
          </div> 
        }
        <h1>Show the users images and stuff they can review</h1>
        <div>
          <p>Get image and data from...</p>
          <p>{this.props.endpoints.dataEndPoint}</p>
          <p>{this.props.endpoints.imgEndPoint}</p>
          <p>{this.props.endpoints.saveEndPoint}</p>
          <div>
            <p>Labels:</p>
            <ul> 
              {this.state.possibleLabels.length > 0 && this.state.possibleLabels.map((label) => {
                return ( 
                  <li>{label}</li>
                )
              })}
            </ul>
            <Button style={{marginRight: 10}} type="primary" onClick={() => this.reviewImages()}>Get images</Button>
            <Button onClick={() => this.addLabels()}>Add Classification Label</Button>
          </div>
          
          {this.state.addingLabels && <div style={{marginTop: 10}}>
            <input placeholder="label" onChange={(e) => this.setState({userAddedLabel: e.target.value})} value={this.state.userAddLabel}/> 
            
            <Button onClick={() => this.saveLabel()}>Save Label</Button>
            
          </div>}
        </div>
        <hr />

        
        {this.state.imgArray.length > 0 && 
          this.state.isMobile 
          ? 
            <ReviewImagesMobile updateImage={this.updateImage} linkArray={this.state.linkArray} imgArray={this.state.imgArray} />     
          :   
            <ReviewImages labels={this.state.possibleLabels} updateImage={this.updateImage} linkArray={this.state.linkArray} imgArray={this.state.imgArray} /> 
        }
      </div>
    );
  }
}

export default Review;